module.exports = __webpack_public_path__ + "static/media/howToPlay2.e38cf8e5.png";